"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _useSummaryContent = require("../../hooks/summary/useSummaryContent");
var _useSummaryFlow = require("../../hooks/summary/useSummaryFlow");
var _CustomIconOrImage = _interopRequireDefault(require("../shared/CustomIconOrImage"));
var _DynamicLoader = _interopRequireDefault(require("../CutomLoader/DynamicLoader"));
var _useLocalTheme = _interopRequireDefault(require("../../hooks/useLocalTheme"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SummaryItem = (0, _styledComponents.default)(_r10SourceLibrary.GridRow)(props => (0, _styledComponents.css)`
    opacity: 0;
    animation-name: ${showItem};
    animation-duration: 10s;
    animation-fill-mode: forwards;
    animation-delay: ${0.5 * (props.index + 1)}s;
  `);
const SummaryItemGrid = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)(() => (0, _styledComponents.css)`
     padding:0;  
     ${_r10SourceLibrary.Mixins.respondTo.md(`
     padding-right: 15px;
     padding-left: 15px;`)}
      `);
const showItem = (0, _styledComponents.keyframes)`
0% {
  opacity: 0;
}
20% {
  opacity: 0.7;
}
40% {
  opacity: 1;
}
100% {
  opacity: 1;
}
`;
const SummaryIcon = _styledComponents.default.div(() => (0, _styledComponents.css)`
    text-align: right;
  `);
const SummaryText = _styledComponents.default.div(() => (0, _styledComponents.css)`
    text-align: left;
    max-width: 350px;
    font-size: 13px;
    ${_r10SourceLibrary.Mixins.respondTo.md(`
      font-size: 18px;
      `)}
  `);
const SummaryBody = () => {
  const {
    summaryTitle,
    summaries
  } = (0, _useSummaryContent.useSummaryContent)();
  (0, _useSummaryFlow.useSummaryFlow)();
  const summaryIcon = (0, _useLocalTheme.default)('summary.icon');
  const name = (summaryIcon === null || summaryIcon === void 0 ? void 0 : summaryIcon.name) || 'success';
  const group = (summaryIcon === null || summaryIcon === void 0 ? void 0 : summaryIcon.group) || 'state';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_DynamicLoader.default, {
    size: 2,
    text: summaryTitle,
    srText: summaryTitle,
    titleTestId: "loading-title",
    indicatorTestId: "summary-loading-indicator"
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, !!(summaries !== null && summaries !== void 0 && summaries.length) && /*#__PURE__*/_react.default.createElement("div", {
    id: "summaryContent"
  }, summaries.map((_ref, index) => {
    var _summary$replace;
    let {
      summary,
      id
    } = _ref;
    return /*#__PURE__*/_react.default.createElement(SummaryItem, {
      index: index,
      key: index
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
      col: 3,
      colMd: 4
    }, /*#__PURE__*/_react.default.createElement(SummaryIcon, null, /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
      size: 4,
      name: name,
      group: group,
      testId: "tick-image"
    }))), /*#__PURE__*/_react.default.createElement(SummaryItemGrid, {
      col: 8,
      colMd: 8
    }, /*#__PURE__*/_react.default.createElement(SummaryText, {
      "data-test-id": "journey-product"
    }, /*#__PURE__*/_react.default.createElement("div", {
      "data-test-id": id,
      dangerouslySetInnerHTML: {
        __html: summary === null || summary === void 0 ? void 0 : (_summary$replace = summary.replace(/<value>/g, '<b>')) === null || _summary$replace === void 0 ? void 0 : _summary$replace.replace(/<\/value>/g, '</b>')
      }
    }))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null));
  })))));
};
var _default = SummaryBody;
exports.default = _default;